import type { MessageHandler, SubscriptionPath, } from "../types";

const { log, } = console;

// globalThis.brktsubs = globalThis.brktsubs || new Map<SubscriptionPath, MessageHandler[]>();

export const subscriptions = new Map<SubscriptionPath, MessageHandler[]>();

export const log_subscriptions = () => {
	const count = subscriptions.size; 
	log("-----")
	log("@bracket/rabbit mqtt:")
	log("subscriptions:");
	log(`count: ${count}`)
	for(const sub of subscriptions) {
		log("???", sub);
	}
	log("-----")
}

globalThis.logsubs = log_subscriptions;
